// @flow
export { default } from './TextInputWithCopyButton';
